<template>
  <customFieldsAddingPreview
    :icon='"browser.svg"'
    :name="preloadedItem.name || 'Weblink'">

    <template :slot='"body"'>
      <v-text-field
        dense
        :placeholder="preloadedItem.placeholder"
        v-model="value"
        :rules="webLinkRules"
        color="#43425d"
        maxlength="128"
        class="r-field item-name-field"/>
    </template>
  </customFieldsAddingPreview>
</template>

<script>
import customFieldsAddingPreview from '../customFieldsAddingPreview'
export default {
  props: {
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null
        }
      }
    }
  },
  data: function() {
    return {
      value: this.preloadedItem.defaultValue,
      webLinkRules: [
        (v) => {
          if (v?.length) {
            const validRegEx = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/
            return validRegEx.test(v) || 'Please enter current web link'
          }
          return true
        }
      ]
    }
  },
  watch: {
    'preloadedItem.defaultValue': {
      handler (newDefaultValue, oldDefaultValue) {
        if (this.value === oldDefaultValue) {
          this.value = newDefaultValue
        }
      },
      deep: true
    }
  },
  components: {
    customFieldsAddingPreview
  }
}
</script>
